
<div class="cmp-contact-form-user-old">
  <ws-input
    ref="login"
    v-model="login"
    name="username"
    :label="$t('scf.user_old.login.label')"
    autocomplete="username"
    :path="path"
    debounce="300"
    required
    :lazy-rules="false"
    :restrict="loginValidation.restriction"
    :rules="[required, ...loginValidation.rules]"
    @input="checkLoginExistence"
  >
    <template v-slot:append>
      <span v-if="loading" class="loading-msg">
        <q-spinner class="q-mr-sm float-left" />
        {{ $t('scf.user_old.login.loading_msg') }}
      </span>
      <span
        v-if="!loading && login && login === model.contact.login"
        class="done-msg"
      >
        <ws-icon
          name="check"
          class="q-mr-sm"
          color="ws-primary"
        />{{ $t('scf.user_old.login.done_msg') }}</span>
    </template>
  </ws-input>
</div>
